<template>
    <div class="cat_product-carousel" style="padding: 50px 0px;">
        <div class="container collection">
            <div class="cat_product__heading">
                <h2 class="cat_product__heading-title">See It All</h2>
                <div class="cat_product__heading-description">
                    <p>
                        <span>Take the reigns off your search and roam our other featured collections.</span>
                    </p>
                </div>
            </div>
            <div class="cat_product-slide">
                <div class="swiper pt_cs_center">
                    <Swiper 
                    class="custom_cate_bottom"
                    :slides-per-view="slidesPerView"
                    :slides-per-group="slidesPerGroup"
                    :spaceBetween="10"
                    :modules="carouselModules"
                    :freeMode="true"
                    :breakpoints="breakpoints"
                    :loop="false"
                    :navigation="{
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev'
                    }"
                    >
                        <SwiperSlide class="coll-slider-item" v-for="item in props.data">
                            <div class="sb-cats__item-details">
                                <a :href="getLangUrl(item.url.url, baseUrl, locale)" rel="noopener noreferrer" class="sb-cats__item-url">
                                    <img :data-original_src="`${baseUrl}api/wp-content/uploads/${item.image_slider}`" :src="`${baseUrl}api/wp-content/uploads/${item.image_slider_lazy}`" alt=""  class="sb-cats__item-thumbnail img_detail">
                                    <span class="sb-cats__item-title">{{ item.title_slider }}</span>
                                </a>
                            </div>
                        </SwiperSlide>
                    </Swiper>
                    <div v-if="showNavigation" class="slider-nav">
                        <button id="prev" class="swiper-button-prev">
                            <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon" transform="rotate(180)">
                                <polyline points="7.5 3 16.5 12 7.5 21" style="fill:none;stroke:rgb(0, 0, 0);stroke-linecap:round;stroke-width:0.816px;"></polyline>
                            </svg>
                        </button>
                        <button id="next" class="swiper-button-next">
                            <svg fill="#000000" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" class="icon">
                                <polyline points="7.5 3 16.5 12 7.5 21" style="fill:none;stroke:rgb(0, 0, 0);stroke-linecap:round;stroke-width:0.816px;"></polyline>
                            </svg>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
    
</template>
<script setup lang="ts">
    const props = defineProps(["data"]);
    const runtimeConfig = useRuntimeConfig();
    const baseUrl = runtimeConfig.public.BASE_URL;
    import { Swiper, SwiperSlide } from "swiper/vue";
    import { FreeMode, Navigation} from "swiper/modules";
    import 'swiper/css/free-mode';
    import "swiper/css";
    import "swiper/css/navigation";
    import { useI18n } from 'vue-i18n';
    const { locale } = useI18n();
    import { getLangUrl } from '~/utils/getLangUrl';
    const slidesPerView = 5;
    const slidesPerGroup = 1;
    const carouselModules = [FreeMode, Navigation];
    const breakpoints = {
        0: { slidesPerView: 2.2, spaceBetween: 10 },
        991: { slidesPerView: 5, centerInsufficientSlides: true },
    };
    const showNavigation = computed(() => props.data.length > 5);
</script>
<style scoped lang="scss">
    .cat_product-carousel  {
        .cat_product__heading-title {
            color: #000;
            line-height: 1.2;
            margin-bottom: 0;
            margin-top: 0;
            text-align: center;
            font-size: 32px;
            font-weight: 700;
            letter-spacing: 1px;
            padding-bottom: 10px;
            font-family: 'DM Serif Text' !important;
        }
        .cat_product__heading-description {
            p {
                color: #000;
                line-height: 1.2;
                margin-bottom: 0;
                margin-top: 0;
                text-align: center;
                font-size: 18px;
                font-weight: 300;
            }
        }
    }
    .cat_product-slide > :nth-child(n+3) {
        display: none;
    }
    .cat_product-carousel .cat_product-slide .cat_product-swiper {
        display: none;
    }
    .cat_product-carousel .coll-slider-item .sb-cats__item-url:before {
        background: #0003;
        content: "";
        display: block;
        height: 100%;
        position: absolute;
        transition: all .2slinear;
        width: 100%;
        z-index: 1;
    }
    .coll-slider-item .sb-cats__item-details:hover .sb-cats__item-thumbnail {
        transform: scale(1.09);
        transition: all 1s ease;
    }
    .coll-slider-item .sb-cats__item-details:hover .sb-cats__item-title:after {
        width: 100%;
    }
    .cat_product-slide {
        padding-top: 30px;
        position: relative;
    }
    .cat_product-carousel .container > .slider-nav {
        display: none;
    }
    .coll-slider-item .sb-cats__item-url {
        display: block;
        position: relative;
        top: 0;
        z-index: 2;
    }

    .coll-slider-item .sb-cats__item-details {
        border: 0;
        border-radius: 5px;
        overflow: hidden;
        position: relative;
    }
    .coll-slider-item .sb-cats__item-thumbnail {
        aspect-ratio: 1;
        display: block;
        -o-object-fit: cover;
        object-fit: cover;
        transition: all .5s;
        width: 100%;
    }
    .coll-slider-item .sb-cats__item-title {
        bottom: 15px;
        color: #fff;
        font-size: 16px;
        font-weight: 600;
        left: 20px;
        margin-bottom: 0;
        margin-left: 0;
        position: absolute;
        text-align: left;
        text-align: -webkit-left;
        text-transform: unset;
        z-index: 1;
    }
    .cat_product-carousel .coll-slider-item .sb-cats__item-url:before {
        background: #0003;
        content: "";
        display: block;
        height: 100%;
        position: absolute;
        transition: all .2s linear;
        width: 100%;
        z-index: 1;
    }
    .coll-slider-item .sb-cats__item-title:after {
        border-bottom: 1px solid #fff;
        content: "";
        display: block;
        position: absolute;
        transition: .5s;
        width: 50%;
    }
    .pt_cs_center .swiper-wrapper {
        justify-content: center !important;
    }
    @media screen and (min-width: 991px) {
        .pt_cs_center .swiper-wrapper {
            justify-content: center !important;
        }
    }
    .pt_cs_arrow  > .slider-nav{
        display: none !important;
    }
    .cat_product-carousel .swiper-button-prev:after, .cat_product-carousel .swiper-button-next:after {
        display: none;
    }
    .cat_product-carousel .swiper:not(cat_product-swiper) .slider-nav #prev {
        left: 0 !important;
    }
    .cat_product-carousel .swiper:not(cat_product-swiper) .slider-nav #next {
        right: 0 !important;
    }
    .cat_product-carousel .slider-nav button.swiper-button-disabled {
        display: none;
    }
    .cat_product-carousel .slider-nav button {
        align-items: center;
        background: #fff9;
        border: 1px solid hsla(0, 0%, 79%, .5);
        border-radius: 5px;
        cursor: pointer;
        display: flex;
        height: 50px;
        justify-content: center;
        line-height: normal;
        margin: 0;
        padding: 0;
        position: absolute;
        text-transform: none;
        top: calc(50% + 30px);
        width: 28px;
        z-index: 1;
    }

    .custom_cate_bottom .coll-slider-item:last-child {
        margin-right: 0 !important;
    }
    .cat_product-carousel .swiper:not(cat_product-swiper) .slider-nav #next {
        right: 0 !important;
    }
    .cat_product-carousel .swiper:not(cat_product-swiper) .slider-nav #prev {
        left: 0 !important;
    }
    .cat_product-carousel .swiper:not(cat_product-swiper) .slider-nav #next,
    .cat_product-carousel .swiper:not(cat_product-swiper) .slider-nav #prev {
        top: calc(50% - 25px);
    }
</style>